import { render, staticRenderFns } from "./MapProductsModal.vue?vue&type=template&id=494fe60f&scoped=true&"
import script from "./MapProductsModal.vue?vue&type=script&lang=js&"
export * from "./MapProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./MapProductsModal.vue?vue&type=style&index=0&id=494fe60f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fe60f",
  null
  
)

export default component.exports